export default __webpack_public_path__ + "static/gatso-69cf1fa27da5d305ffa2536a815ccef7.png";